
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SchoolProfileResponse } from "../../models/dtos";

export const schoolProfilesApi = createApi({
  reducerPath: 'schoolProfilesApi',
  baseQuery: baseAuthQuery('SchoolProfiles'),
  tagTypes: ['SchoolProfile'],
  endpoints: (builder) => ({
    getSchoolProfiles: builder.query<ApiResponse<SchoolProfileResponse[]>, void>({
      query: () => "",
      providesTags: ['SchoolProfile'],
    }),
    getSchoolProfileById: builder.query<ApiResponse<SchoolProfileResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SchoolProfile'],
    }),
    updateSchoolProfile: builder.mutation<ApiResponse<SchoolProfileResponse>, Partial<SchoolProfileResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SchoolProfile'],
    }),
    deleteSchoolProfile: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SchoolProfile'],
    }),
  }),
});
